import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/layout/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Committee from "@/pages/Committee";
import Payment from "@/pages/Payment";
import Dashboard from "@/pages/Dashboard";
import Gallery from "@/pages/Gallery";
import Admin from "@/pages/Admin";
import AdminContent from "@/pages/AdminContent";
import Placeholder from "@/pages/Placeholder";
import Updates from "@/pages/Updates";

function App() {
  return (
    <div className="App" data-testid="apicon-app-root">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/committee" element={<Committee />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/updates" element={<Updates />} />
              <Route
                path="/payment"
                element={
                  <ProtectedRoute>
                    <Payment />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <AdminRoute>
                    <Admin />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/content"
                element={
                  <AdminRoute>
                    <AdminContent />
                  </AdminRoute>
                }
              />
              <Route
                path="/blog"
                element={
                  <Placeholder
                    title="Blog"
                    eyebrow="Insights & Announcements"
                    description="Curated articles, updates from the scientific committee and speaker spotlights will appear here."
                    testId="page-blog"
                  />
                }
              />
              <Route
                path="*"
                element={
                  <Placeholder
                    title="404"
                    eyebrow="Page not found"
                    description="The page you’re looking for doesn’t exist yet. Head back to the home page."
                    testId="page-404"
                  />
                }
              />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
